export const appleTvProductId = 1270;
export const disneyPlusProductId = 1271;
export const skyShowtimeProductId = 1268;
export const appleTvDisneyPlusProductId = 1290;
export const PRODUCT_NAMES_BY_ID: Record<number, string> = {
  [appleTvProductId]: 'Apple TV',
  [disneyPlusProductId]: 'Disney+',
  [skyShowtimeProductId]: 'SkyShowtime',
  [appleTvDisneyPlusProductId]: 'Apple TV & Disney+',
};
export const availableAddonStates: Record<string, string> = {
  activated: 'ACTIVATED',
  closed: 'CLOSED',
  pendingActivation: 'PENDING_ACTIVATION',
};
export const getProductName = (productId: number | string): string => {
  if (Object.prototype.hasOwnProperty.call(PRODUCT_NAMES_BY_ID, productId)) {
    return PRODUCT_NAMES_BY_ID[productId as number];
  }

  return `Product ${productId}`;
};
